// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_9a658f09","outerContainer":"_4c13d810","secondaryToolbar":"_91ffc75e","doorHangerRight":"e9fb967c","toolbarContainer":"_9d3a725d","toolbarViewerMiddle":"daa4b1fe","progressBar":"f94253bf","back-to-application":"_78b7bb04","placeholder":"b4bcbbdb","title":"_3897e7f9","subtitle":"_144e1b59"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/ActiveSpeaker/Placeholder/styles.styl
// module id = 5152
// module chunks = 39